import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import './App.scss';

import './orgHeadConfig';

import App from './App';
import AuthPersist from './components/pages/Login/AuthPersist';
import store from './store';

const container = document.getElementById('root');

if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <AuthPersist>
          <App />
        </AuthPersist>
      </Provider>
    </React.StrictMode>,
  );
}
